import { useEffect, useRef } from "react";
import { Sidenav } from "@materializecss/materialize";

function scrollToSection(id) {
  const targetSection = document.getElementById(id);
  if (targetSection) {
    targetSection.scrollIntoView({ behavior: 'smooth' });
  }
}

const Navbar = () => {
  const sidenavRef = useRef(null);

  useEffect(() => {
    if (sidenavRef.current) {
      Sidenav.init(sidenavRef.current, { edge: 'right' });
    }
  }, []);

  const closeSidenav = () => {
    if (sidenavRef.current) {
      const instance = Sidenav.getInstance(sidenavRef.current);
      if (instance) instance.close();
    }
  };

  const goTo = (id) => {
    closeSidenav();
    scrollToSection(id);
  };

  return (
    <>
      <nav className="site-nav nav-wrapper">
        <div className="site-nav__inner container">
          <button
            type="button"
            className="site-nav__brand"
            onClick={() => goTo("top")}
            aria-label="Select Data Labs home"
          >
            <img src="img/SDL_logo_long.svg" alt="Select Data Labs" />
          </button>

          <ul className="site-nav__links">
            <li>
              <button type="button" className="nav-link" onClick={() => goTo('solutions')}>
                Solutions
              </button>
            </li>
            <li>
              <button type="button" className="nav-link" onClick={() => goTo('howWeWork')}>
                How we work
              </button>
            </li>
            <li>
              <button type="button" className="nav-link" onClick={() => goTo('clients')}>
                Clients
              </button>
            </li>
            <li>
              <button
                type="button"
                className="get-in-touch-icn modal-trigger"
                data-target="contactModal"
              >
                Get in touch
              </button>
            </li>
          </ul>

          <button
            type="button"
            className="site-nav__hamburger sidenav-trigger"
            data-target="mobile-sidenav"
            aria-label="Open menu"
          >
            <i className="material-icons">menu</i>
          </button>
        </div>
      </nav>

      <ul id="mobile-sidenav" className="sidenav" ref={sidenavRef}>
        <li>
          <button type="button" className="nav-link" onClick={() => goTo('solutions')}>
            Solutions
          </button>
        </li>
        <li>
          <button type="button" className="nav-link" onClick={() => goTo('howWeWork')}>
            How we work
          </button>
        </li>
        <li>
          <button type="button" className="nav-link" onClick={() => goTo('clients')}>
            Clients
          </button>
        </li>
        <li>
          <button
            type="button"
            className="nav-link modal-trigger"
            data-target="contactModal"
            onClick={closeSidenav}
          >
            Get in touch
          </button>
        </li>
      </ul>
    </>
  );
};

export default Navbar;

export {
  scrollToSection,
};
